import React from "react";

function Icon() {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.333 8.66671H18.6663V12H15.333V8.66671ZM16.9997 25.3334C17.9163 25.3334 18.6663 24.5834 18.6663 23.6667V17C18.6663 16.0834 17.9163 15.3334 16.9997 15.3334C16.083 15.3334 15.333 16.0834 15.333 17V23.6667C15.333 24.5834 16.083 25.3334 16.9997 25.3334ZM16.9997 0.333374C7.79967 0.333374 0.333008 7.80004 0.333008 17C0.333008 26.2 7.79967 33.6667 16.9997 33.6667C26.1997 33.6667 33.6663 26.2 33.6663 17C33.6663 7.80004 26.1997 0.333374 16.9997 0.333374ZM16.9997 30.3334C9.64968 30.3334 3.66634 24.35 3.66634 17C3.66634 9.65004 9.64968 3.66671 16.9997 3.66671C24.3497 3.66671 30.333 9.65004 30.333 17C30.333 24.35 24.3497 30.3334 16.9997 30.3334Z" fill="white"/>
    </svg>

  );
}

export default Icon;
